export const createBlockquote = (className) => {
  const blockquote = document.createElement(`blockquote`);
  blockquote.className = className;

  return blockquote;
};
